import axios from "axios";
import crudApi from "./crudApi";
import {API_DELIVERY_POINTS} from '../api.js';

class DeliveryPoint extends crudApi {
    async create(data, options = {}) {
        return await axios.post(API_DELIVERY_POINTS, data, options);
    }
    async edit(data, options = {}) {
        return await axios.patch(`${API_DELIVERY_POINTS}/${data.id}`, data, options);
    }
    async remove(data, options = {}) {
        return await axios.delete(`${API_DELIVERY_POINTS}/${data.id}`, options);
    }
    async getTransportDetail(id, options = {}){
        return await axios.get(`${API_DELIVERY_POINTS}/${id}/transport_details`, options)
    }
    async getTransportReport(id, options = {}){
        return await axios.get(`${API_DELIVERY_POINTS}/${id}/delivery_report`, options)
    }
    async getTransportRowReport(id, options = {}){
        return await axios.get(`${API_DELIVERY_POINTS}/${id}/row_delivery_report`, options)
    }
    async getQrCodeReport(id, options = {}){
        return await axios.get(`${API_DELIVERY_POINTS}/${id}/qr_code_report`, options)
    }
};

export default new DeliveryPoint(API_DELIVERY_POINTS);
